export const Lock = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>lock</title>
      <g
        id="页面-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Log-In-" transform="translate(-779, -522)">
          <g id="account备份" transform="translate(768, 474)">
            <g id="Vector" transform="translate(11, 48)">
              <path
                d="M6,10 L6,8 C6,4.69000006 7,2 12,2 C17,2 18,4.69000006 18,8 L18,10"
                stroke="#151B33"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
                fillRule="nonzero"
              ></path>
              <path
                d="M7,22 C3,22 2,21 2,17 L2,15 C2,11 3,10 7,10 L17,10 C21,10 22,11 22,15 L22,17 C22,21 21,22 17,22 L7,22 Z"
                stroke="#151B33"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
                fillRule="nonzero"
              ></path>
              <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z" opacity="0"></path>
              <line
                x1="15.9964605"
                y1="16"
                x2="16.0054424"
                y2="16"
                stroke="#151B33"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
              ></line>
              <line
                x1="11.9954839"
                y1="16"
                x2="12.0044658"
                y2="16"
                stroke="#151B33"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
              ></line>
              <line
                x1="7.99450733"
                y1="16"
                x2="8.00348927"
                y2="16"
                stroke="#151B33"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="0,0"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CheckCircleOutlined = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>check-circle-outlined</title>
      <g
        id="页面-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Log-In-icon-change"
          transform="translate(-779, -605)"
          fill="#000000"
        >
          <g id="check-circle-outlined" transform="translate(779, 605)">
            <rect
              id="矩形"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            ></rect>
            <path
              d="M16.3828125,8.2734375 L15.2835938,8.2734375 C15.0445313,8.2734375 14.8171875,8.38828125 14.6765625,8.58515625 L10.9921875,13.6945313 L9.3234375,11.3789063 C9.1828125,11.184375 8.9578125,11.0671875 8.71640625,11.0671875 L7.6171875,11.0671875 C7.46484375,11.0671875 7.37578125,11.240625 7.46484375,11.3648438 L10.3851562,15.4148437 C10.6828125,15.8296875 11.2992187,15.8296875 11.596875,15.4148437 L16.5328125,8.57109375 C16.6242188,8.446875 16.5351563,8.2734375 16.3828125,8.2734375 Z"
              id="路径"
            ></path>
            <path
              d="M12,1.5 C6.2015625,1.5 1.5,6.2015625 1.5,12 C1.5,17.7984375 6.2015625,22.5 12,22.5 C17.7984375,22.5 22.5,17.7984375 22.5,12 C22.5,6.2015625 17.7984375,1.5 12,1.5 Z M12,20.71875 C7.1859375,20.71875 3.28125,16.8140625 3.28125,12 C3.28125,7.1859375 7.1859375,3.28125 12,3.28125 C16.8140625,3.28125 20.71875,7.1859375 20.71875,12 C20.71875,16.8140625 16.8140625,20.71875 12,20.71875 Z"
              id="形状"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CheckCircle = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>check-circle</title>
      <g
        id="页面-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Log-In-" transform="translate(-779, -605)">
          <g id="check-circle" transform="translate(779, 605)">
            <rect
              id="矩形"
              fill="#151B33"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            ></rect>
            <path
              d="M12,1.5 C6.2015625,1.5 1.5,6.2015625 1.5,12 C1.5,17.7984375 6.2015625,22.5 12,22.5 C17.7984375,22.5 22.5,17.7984375 22.5,12 C22.5,6.2015625 17.7984375,1.5 12,1.5 Z M12,20.71875 C7.1859375,20.71875 3.28125,16.8140625 3.28125,12 C3.28125,7.1859375 7.1859375,3.28125 12,3.28125 C16.8140625,3.28125 20.71875,7.1859375 20.71875,12 C20.71875,16.8140625 16.8140625,20.71875 12,20.71875 Z"
              id="形状"
              fill="#000000"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
